import React from 'react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import TronLogo from '../tron-logo.png';

const Footer = () => {
  return (
    <footer>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          paddingBottom: '20px',
          paddingTop: '20px'
        }}
      >
        <Typography sx={{ paddingRight: '5px' }}>Powered by</Typography>
        <img src={TronLogo} alt='Tron Logo' height='25' width='72' />
      </Box>
    </footer>
  );
};

export { Footer };
